export default __webpack_public_path__ + "static/academy-hero-first-glow-3938cfad68a98f489dafbfe0271fca7e.svg";